(() => {
  const panel = document.getElementById('LebbuyWishlist');
  if (!panel) return;
  const key = 'lebbuy-wishlist-v1';
  const status = document.getElementById('LebbuyWishlistStatus');
  const labels = panel.dataset;
  const valid = item => item && typeof item.handle === 'string' && /^[a-z0-9-]+$/.test(item.handle) && typeof item.title === 'string';
  const read = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(parsed) ? parsed.filter(valid).slice(0,200) : [];
    } catch { return []; }
  };
  let items = read();
  let opener;
  const announce = message => { status.textContent = message; };
  const sync = () => {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const saved = items.some(item => item.handle === button.dataset.handle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? labels.removeLabel : labels.addLabel}: ${button.dataset.title}`);
      const label = button.querySelector('[data-wishlist-label]');
      if (label && label.textContent !== (saved ? labels.removeLabel : labels.addLabel)) label.textContent = saved ? labels.removeLabel : labels.addLabel;
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(count => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
  };
  const save = next => {
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch { announce(labels.errorLabel); return false; }
    items = next;
    sync();
    return true;
  };
  const render = () => {
    const list = panel.querySelector('[data-wishlist-items]');
    list.replaceChildren();
    panel.querySelector('[data-wishlist-empty]').hidden = items.length > 0;
    items.forEach(item => {
      const row = document.createElement('li');
      row.className = 'lebbuy-wishlist-item';
      const image = document.createElement('img');
      image.alt = '';
      image.loading = 'lazy';
      if (typeof item.image === 'string') {
        try {
          const url = new URL(item.image, location.origin);
          if (url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com')) image.src = url.href;
        } catch {}
      }
      const detail = document.createElement('div');
      const title = document.createElement('a');
      const root = window.Shopify?.routes?.root || '/';
      title.href = `${root}products/${item.handle}`;
      title.textContent = item.title;
      const actions = document.createElement('div');
      actions.className = 'lebbuy-wishlist-actions';
      const view = document.createElement('a');
      view.href = title.href;
      view.textContent = labels.viewLabel;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = labels.removeLabel;
      remove.setAttribute('aria-label', `${labels.removeLabel}: ${item.title}`);
      remove.addEventListener('click', () => {
        if (save(items.filter(saved => saved.handle !== item.handle))) {
          render();
          panel.querySelector('[data-wishlist-close]').focus();
          announce(labels.removedLabel);
        }
      });
      actions.append(view, remove);
      detail.append(title, actions);
      row.append(image, detail);
      list.append(row);
    });
  };
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const exists = items.some(item => item.handle === toggle.dataset.handle);
      const entry = {handle:toggle.dataset.handle,title:toggle.dataset.title,image:toggle.dataset.image};
      if (!valid(entry)) return;
      const next = exists ? items.filter(item => item.handle !== entry.handle) : [...items.filter(valid),entry];
      if (save(next)) announce(exists ? labels.removedLabel : labels.savedLabel);
      return;
    }
    const open = event.target.closest('[data-wishlist-open]');
    if (open) {
      opener = open;
      items = read();
      sync();
      render();
      panel.showModal();
      return;
    }
    if (event.target.closest('[data-wishlist-close]')) panel.close();
    if (event.target === panel) {
      const rect = panel.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
    }
  }, true);
  panel.addEventListener('close', () => opener?.focus());
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) { items = read(); sync(); if (panel.open) render(); }
  });
  const observer = new MutationObserver(sync);
  observer.observe(document.getElementById('MainContent'), {childList:true,subtree:true});
  sync();
})();
